import React from 'react'
import './Home.scss';

function Home() {
  return (
    <div>Home</div>
  )
}

export default Home